const BASE_URL = "https://vxfrpghksl.execute-api.us-east-1.amazonaws.com/production";

export const request = async (endpoint, options = {}) => {
  // 1. Configuración de headers
  const headers = {
    "Content-Type": "application/json",
    ...options.headers
  };

  // 2. Adjuntar token de sesión si existe (para futuras peticiones protegidas)
  /*const token = localStorage.getItem("userToken");
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
*/
  const config = {
    ...options,
    headers
  };

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, config);

    // Manejo de errores HTTP (400, 401, 500, etc.)
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Error en la petición");
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};
